var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7349 32.49V28.6787C47.7349 26.5738 46.0286 24.8675 43.9237 24.8675H5.81124C3.70635 24.8675 2 26.5738 2 28.6787V51.5462C2 53.6511 3.70635 55.3574 5.81124 55.3574H43.9237C46.0286 55.3574 47.7349 53.6511 47.7349 51.5462V47.7349M47.7349 32.49H32.49C28.2802 32.49 24.8675 35.9027 24.8675 40.1124C24.8675 44.3223 28.2802 47.7349 32.49 47.7349H47.7349M47.7349 32.49C51.9448 32.49 55.3574 35.9027 55.3574 40.1124C55.3574 44.3223 51.9448 47.7349 47.7349 47.7349M13.4337 24.8675V13.4337C13.4337 7.11907 18.5528 2 24.8675 2C31.1821 2 36.3012 7.11907 36.3012 13.4337V24.8675M45.8293 40.1124H49.6406M38.2068 40.1124H42.0181M30.5843 40.1124H34.3956",
    stroke: "#424242",
    strokeWidth: 3.37638
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.59f01276a325293845caba9a69333483.svg";
export { ForwardRef as ReactComponent };